import {
  REQUEST_MANAGER_FEE_NOTES,
  REQUEST_OPENING_MANAGER_FEE_NOTES,
  REQUEST_FEE_NOTES_BY_CLAIM_NUMBER,
  MAKE_DECISION_FEE_NOTE,
  REQUEST_ALL_FEE_NOTES,
  REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS,
  REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER,
  REQUEST_MANAGER_ALL_FEE_NOTES,
  REQUEST_CREATE_FEE_NOTE_MANAGER,
  REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS,
  REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER,
} from 'containers/LawyerFeeNote/constants';
import { FeeNote } from 'containers/LawyerFeeNote/typings';

export const requestManagerFeeNotes = (
  status: string,
  page: number,
  pageSize: number,
  transactionInboxeAreaId: any,
) => ({
  type: REQUEST_MANAGER_FEE_NOTES,
  status,
  page,
  pageSize,
  transactionInboxeAreaId,
});
export const requestAllFeeNotes = (page: number, pageSize: number) => ({
  type: REQUEST_ALL_FEE_NOTES,
  page,
  pageSize,
});
export const requestFeeNotesByClaimNumb = (
  claimNumber: string,
  transactionAreaId?: any,
  viewByClaim?: boolean,
  claimId?: string,
) => {
  return {
    type: REQUEST_FEE_NOTES_BY_CLAIM_NUMBER,
    claimNumber,
    transactionAreaId,
    viewByClaim,
    claimId,
  };
};

export const requestOpeningManagerFeeNotes = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_OPENING_MANAGER_FEE_NOTES,
  status,
  page,
  pageSize,
});

export const makeDecisionFeeNote = (
  decision: any,
  successCallBack: Function,
) => ({
  type: MAKE_DECISION_FEE_NOTE,
  decision,
  successCallBack,
});
export const requestFeeNoteExceptionalCosts = (
  feeNote: FeeNote,
  successCallBack: Function,
) => ({
  type: REQUEST_FEE_NOTE_EXCEPTIONAL_COSTS,
  feeNote,
  successCallBack,
});

export const requestFeeNotesByPolicyNumber = (
  policyNumber: string,
  transactionAreaId?: any,
) => {
  return {
    type: REQUEST_MANAGER_FEE_NOTES_BY_POLICY_NUMBER,
    policyNumber,
    transactionAreaId,
  };
};
export const requestManagerAllFeeNotes = (status: string) => {
  return {
    type: REQUEST_MANAGER_ALL_FEE_NOTES,
    status,
  };
};

export const requestCreateFeeNoteManager = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_CREATE_FEE_NOTE_MANAGER,
  payload,
  successCallBack,
});

export const requestCreateCostsSagis = (
  payload: any,
  successCallBack: Function,
) => ({
  type: REQUEST_ADD_FEE_NOTE_EXCEPTIONAL_COSTS_SAGIS,
  payload,
  successCallBack,
});

export const requestFeeNotesByRegistrationNumber = (
  registrationNumber: string,
  transactionAreaId?: any,
) => {
  return {
    type: REQUEST_MANAGER_FEE_NOTES_BY_REGISTRATION_NUMBER,
    registrationNumber,
    transactionAreaId,
  };
};
